import { ReactComponent as PlusIcon } from "../../shared/assets/plus.svg";
import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { components, MenuListProps, GroupBase } from "react-select";
import { twMerge } from "tailwind-merge";

// Adjust the type definition to include your custom props along with the MenuListProps
interface CustomMenuListProps<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
  extends MenuListProps<Option, IsMulti, Group> {
  setShowInput: (show: boolean) => void; // Assuming this is your custom prop
}

// Make sure to correctly type your component with generic types for flexibility
const CustomMenuList = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  setShowInput,
  ...props // Spread the rest of the props to catch all MenuListProps
}: CustomMenuListProps<Option, IsMulti, Group>) => {
  const theme = useAtomValue(themeAtom);

  return (
    // Spread the required MenuListProps into the default component
    <components.MenuList {...props}>
      <div className={twMerge(theme.vesselDetails.info, "text-sm")}>{children}</div>

      <div
        className={twMerge("flex cursor-pointer items-center justify-center p-2", theme.vesselDetails.hover)}
        onClick={() => setShowInput(true)}
      >
        <PlusIcon className={twMerge("h-5 w-5", theme.uwhcAssistant.text)} />{" "}
        <p className={twMerge("pl-2", theme.uwhcAssistant.text)}>Create a new task</p>
      </div>
    </components.MenuList>
  );
};

export default CustomMenuList;
